<template>
    <div class="cdkey" :class="{show: isShow}">
      <div class="cdkey-box" :class="{show: type==='created' && !activationCode}">
        <div class="box">
          <div class="title">
            <div class="str" v-if="!isPay">生成激活码</div>
            <div class="str" v-else>支付成功，是否生成激活码</div>
            <div class="close el-icon-close" @click="close"></div>
          </div>
          <div class="body" style="flex-direction:column">
            <el-input v-model="machineCode" placeholder="输入您的注册码"></el-input>
            <div class="info" style="font-size: 13px;color: #909090;margin-top:15px;text-align:left">
                <span class="el-icon-warning-outline"></span>
                注册码请到蝉鸣后台获取
            </div>
          </div>
          <div class="buttons">
            <el-button type="primary" @click="createdCDKEY">确认</el-button>
            <el-button @click="isShow = false" v-if="!isPay">取消</el-button>
            <el-button @click="skip" v-else>跳过</el-button>
          </div>
        </div>
      </div>
      <div class="cdkey-box" :class="{show: type==='created' && activationCode}">
        <div class="box">
          <div class="title">
            <div class="str">生成激活码</div>
            <div class="close el-icon-close" @click="close"></div>
          </div>
          <div class="body code" style="flex-direction:column">
              {{activationCode}}
              <div class="info" style="font-size: 13px;color: #909090;margin-top:15px;text-align:left">
                  <span class="el-icon-warning-outline"></span>
                  请在蝉鸣后台输入以上激活码激活系统
              </div>
          </div>
          <div class="buttons">
            <el-button type="primary" 
              v-clipboard:copy="activationCode" 
              v-clipboard:success="()=>$message({showClose: true,message:'复制成功！',type:'success'})" 
              v-clipboard:error="()=>$message({showClose: true,message:'复制失败，请手动复制',type:'error'})">点击复制</el-button>
          </div>
        </div>
      </div>
      <div class="cdkey-box" :class="{show: type==='viewMachineCode'}">
        <div class="box">
          <div class="title">
            <div class="str">查看注册码</div>
            <div class="close el-icon-close" @click="close"></div>
          </div>
          <div class="body code">
              {{machineCode}}
          </div>
          <div class="buttons">
            <el-button type="primary" 
              v-clipboard:copy="machineCode" 
              v-clipboard:success="()=>$message({showClose: true,message:'复制成功！',type:'success'})" 
              v-clipboard:error="()=>$message({showClose: true,message:'复制失败，请手动复制',type:'error'})">点击复制</el-button>
          </div>
        </div>
      </div>
      <div class="cdkey-box" :class="{show: type==='viewActivationCode'}">
        <div class="box show">
          <div class="title">
            <div class="str">查看激活码</div>
            <div class="close el-icon-close" @click="close"></div>
          </div>
          <div class="body code" style="flex-direction:column">
              {{activationCode}}
              <div class="info" style="font-size: 13px;color: #909090;margin-top:15px;text-align:left">
                  <span class="el-icon-warning-outline"></span>
                  请在蝉鸣后台输入以上激活码激活系统
              </div>
          </div>
          <div class="buttons">
            <el-button type="primary" 
              v-clipboard:copy="activationCode" 
              v-clipboard:success="()=>$message({showClose: true,message:'复制成功！',type:'success'})" 
              v-clipboard:error="()=>$message({showClose: true,message:'复制失败，请手动复制',type:'error'})">点击复制</el-button>
          </div>
        </div>
      </div>
        <!-- <template v-if="!activationCode">
          <div>
            输入您的机器码：<el-input v-model="machineCode"></el-input>
          </div>
          <div>
              <el-button @click="isShow = false">取消</el-button>
              <el-button type="primary" @click="createdCDKEY">下一步</el-button>
          </div>
        </template>
        <template v-else>
          <div>生成激活码成功，请在蝉鸣管理后台使用！</div>
          <h1>{{activationCode}}</h1>
          <div>
            <el-button @click="close">关闭</el-button>
          </div>
        </template> -->
    </div>
</template>
<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
.cdkey{
  position: fixed;
  width: 100vw;
  height:100vh;
  right:0px;
  bottom:0px;
  background:rgba(0,0,0,0.5);
  opacity: 0;
  z-index: 100;
  transition: opacity 0.5s;
  transform: translateX(100vw);
  display:flex;
  justify-content: center;
  align-items: center;
  &.show{
    opacity: 1;
      transform: translateX(0px);
  }
  .cdkey-box{
    position: fixed;
    width: 100vw;
    height:100vh;
    right:0px;
    bottom:0px;
    // background:rgba(0,0,0,0.5);
    opacity: 0;
    z-index: 100;
    transition: opacity 0.5s;
    transform: translateX(100vw);
    display:flex;
    justify-content: center;
    align-items: center;
    &.show{
      transform: translateX(0);
      opacity: 1;
    }
    .box{
      // padding:30px;
      width: 80%;
      max-width:450px;
      background: #FFFFFF;
      box-shadow: 0px 4px 8px 0px rgba(0, 79, 66, 0.16);
      border-radius: 2px;
      .title{
        line-height:48px;
        justify-content: space-between;
        padding:0 15px;
        border-bottom:1px solid #ddd;
        display: flex;
        align-items: center;
        .str{
          font-size:18px;
          font-weight: bold;
        }
        .close{
          transition: all 0.5s;
          &:hover{
            transform: rotate(360deg);
          }
        }
      }
      .body{
        text-align: center;
        padding:5% 30px;
        &.code{
          word-break: break-word;
        }
      }
      .buttons{
        text-align: center;
        padding-bottom:20px;
      }
    }
  }
}
</style>

<script>
import server from "@/public/service"
import {SUCCESS_CODE} from "@/public/state";
import getInterfaceData from "@/public/service/getInterfaceData";
export default {
  name: 'cdkey',
  data(){
    return {
      isShow: false,
      isPay:false,
      machineCode: "",
      activationCode:"",
      orderId:"",
      type: "created",//created生成激活码，viewMachineCode 查看机器码，viewActivationCode查看激活码
    }
  },
  props: {
    callback: Function,
    payCallback: Function
  },
  methods:{
      skip(){
        this.isShow = false;
        if(this.payCallback){
          this.payCallback();
        }
      },
      createdCDKEY(){
        if(!this.machineCode){
          return this.$message({
            message:"请填写注册码",
            showClose: true,
            type:"warning"
          });
        }
        if(!this.orderId) return; 
        var params = {
            orderId: this.orderId,
            machineCode: this.machineCode,
        };
        server.createdCDKEY(params).then(data=>{
            if(data.reCode === SUCCESS_CODE){
                var result = getInterfaceData(data);
                this.activationCode = result || "";
                if(this.callback){
                  this.callback();
                };
            };
        });
      },
      show(orderId,{isPay}={}){
        // console.log("show",orderId)
        if(!orderId) return;
        this.orderId = orderId;
        this.machineCode = "";
        this.activationCode ="";
        this.type="created"
        this.isShow = true;
        this.isPay = !!isPay;
        console.log("show cdkey",orderId,this)
      },
      close(){
        this.isShow = false;
        if(this.isPay && this.payCallback){
          this.payCallback();
        }
      },
      viewMachineCode(code){
        console.log("componeny viewMachineCode",code)
        this.machineCode = code;
        this.isShow = true;
        this.type="viewMachineCode";
      },
      viewActivationCode(code){
        console.log("componeny viewActivationCode",code)
        this.activationCode = code;
        this.isShow = true;
        this.type="viewActivationCode";
      }
  },
  created(){
    console.log("cdkey component",this.callback)
  }
}
</script>
